import { PRODUCT_ATTRIBUTION_EVENTS } from "../data-layer/config.js";

// Re-export der zentral definierten ProductAttribution Events
export default PRODUCT_ATTRIBUTION_EVENTS;
